// eslint-disable-next-line no-shadow
export enum CanvasShareMode {
	PUBLIC = 'public',
	PRIVATE = 'private',
}
